import { get } from "lodash";
import IUser from "../../types/services/IUser";
import { isOnboardingComplete, isOnboardingRequired } from "./onboardingChecker";
import { ONBOARDING_DASHBOARD_PATH } from "./stepNavigation";

export const ONBOARDING_OPERATOR_CLAIM = "onboardingOperator";

export function isOnboardingOperatorClaim(
  claims: Record<string, unknown>
): boolean {
  const value = claims[ONBOARDING_OPERATOR_CLAIM];
  return value === true || value === "true";
}

export function canAccessOnboardingSession(
  user: Pick<IUser, "isSuperadmin" | "isOnboardingOperator">,
  onboardingRequired: boolean
): boolean {
  if (!onboardingRequired) {
    return false;
  }
  return Boolean(user.isSuperadmin || user.isOnboardingOperator);
}

export function canMaintainCharitySetup(
  user: Pick<IUser, "isSuperadmin">
): boolean {
  return Boolean(user.isSuperadmin);
}

export function resolvePostLoginDestination(
  user: Pick<IUser, "isSuperadmin" | "isOnboardingOperator">,
  charityId: string,
  firebaseData: Record<string, unknown> | undefined,
  onboardingRequiredOverride?: boolean
): typeof ONBOARDING_DASHBOARD_PATH | "/contacts" {
  if (!charityId) {
    return "/contacts";
  }
  const onboardingRequired =
    typeof onboardingRequiredOverride === "boolean"
      ? onboardingRequiredOverride
      : isOnboardingRequired(charityId, firebaseData);

  if (!canAccessOnboardingSession(user, onboardingRequired)) {
    return "/contacts";
  }
  return isOnboardingComplete(charityId, firebaseData)
    ? "/contacts"
    : ONBOARDING_DASHBOARD_PATH;
}

export function canUseSharedTcrOption(
  user: Pick<IUser, "isSuperadmin" | "isOnboardingOperator">
): boolean {
  return Boolean(user.isSuperadmin || !user.isOnboardingOperator);
}

export function showOnboardingNav(
  user: Pick<IUser, "isSuperadmin" | "isOnboardingOperator">,
  firebaseData: Record<string, unknown> | undefined,
  charityId: string
): boolean {
  return canAccessOnboardingSession(
    user,
    isOnboardingRequired(charityId, firebaseData)
  );
}
